let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Lui6s")).then(() => parcelRequire('bfFnE'));